import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { CONFIRMATION_TYPES, ConfirmationModel, NotificationIdentifierModel } from '@evorait/pace-core';
import { ConfirmationDataInstanceToken, ConfirmationDataInterface } from '../interfaces/confirmation-data.interface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConfirmationResolver implements Resolve<Observable<ConfirmationModel>> {
    public constructor(
        @Inject(ConfirmationDataInstanceToken) private readonly confirmationService: ConfirmationDataInterface,
    ) {}

    public resolve(route: ActivatedRouteSnapshot): Observable<ConfirmationModel> {
        const id = new NotificationIdentifierModel(
            route.paramMap.get('frontid') || '',
            route.paramMap.get('qmnum') || '',
            route.paramMap.get('manum') || '',
        );
        return this.confirmationService.getConfirmation(
            id,
            (route.paramMap.get('crmtype') as CONFIRMATION_TYPES) || CONFIRMATION_TYPES.NORMAL,
        );
    }
}
